import axios from '../utils/axios';

export default function fetchRecruitersDetails(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/ref-apply-analysis', { params })
    )
}
